export enum PortfolioBaseType {
  PORTFOLIO_CHART = 'Portfolio Chart',
  SECTOR_BREAKDOWN = 'Sector Breakdown',
}
